module.exports = __webpack_public_path__ + "img/header.9fd4c895.jpg";